<template>
<div>
  <field :label="label" :required="required" :classes="classes" v-model="newValue" :collection="countries" :name="name" :value="value" :placeholder="placeholder" type="select" :disabled="disabled"></field>
</div>
</template>
<script>
import Field from '@/components/helpers/DataInput/FormField'
import Countries from '@/config/data/countries'

export default {
  components: { Field },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: [String, Boolean],
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: 'en'
    },
    params: {
      type: Object,
      default: ()=>{}
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      countries: {},
      newValue: '',
      favorites: []
    }
  },
  created () {
    if(_.get(this, 'params.favorites')){
      this.favorites = this.params.favorites
    }

    // to use favorites, put a prop to the country-select item like this:
    // :params="{favorites: ['DE', 'CH']}"

    let countries = _.orderBy(Countries[this.language], ['name'],['asc'])

    var evens = _.remove(countries, n=>{
      return this.favorites.includes(n.value)
    });

    if(evens.length > 0){
      countries.unshift({name:'----', value: null})
      countries.unshift(...evens)
    }

    this.countries = countries
    this.newValue = this.value
  },
  watch: {
    value() {
      this.newValue = this.value
    },
    newValue () {
      this.$emit('input', this.newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CountrySelect.vue?1478dbd2